import { defineMessages } from 'react-intl';

export default defineMessages({
	featuredPortalsTitle: {
		defaultMessage: 'Featured',
		description: 'Title for featured portals loader section',
		id: 'cv.portal.reordering.experience.loader.featured.portals.title',
	},
});
